import React from 'react';
import ReactECharts from 'echarts-for-react';
import { StatusColor } from '../../../environment';

export const ChartBar: React.FC = () => {

    const options = {
        title: {
            text: 'Execution Status',
            subtext: 'TestScenario',

        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        toolbox: {
            feature: {
                dataView: { show: true, readOnly: false },
                magicType: { show: true, type: ['line', 'bar'] },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },

        grid: {
            left: '1%',
            right: '1%',
            bottom: '1%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: ['No Run', 'Pending', 'Running', 'Passed', 'Failed', 'Blocked', 'Warning']
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                type: 'bar',
                showBackground: true,
                data: [
                    {
                        value: 120,
                        itemStyle: {
                            color: StatusColor.noRun
                        }
                    },
                    {
                        value: 200,
                        itemStyle: {
                            color: StatusColor.pending
                        }
                    },
                    {
                        value: 150,
                        itemStyle: {
                            color: StatusColor.running
                        }
                    },
                    {
                        value: 80,
                        itemStyle: {
                            color: StatusColor.passed
                        }
                    },
                    {
                        value: 200,
                        itemStyle: {
                            color: StatusColor.failed
                        }
                    },
                    {
                        value: 110,
                        itemStyle: {
                            color: StatusColor.blocked
                        }
                    },
                    {
                        value: 130,
                        itemStyle: {
                            color: StatusColor.warning
                        }
                    },
                    
                ],
            }
        ]
    };

    return <ReactECharts
        option={options}
        theme='tdTheme'
    />;
};